import React from 'react';
import Popup from '../Popup';
import Room from '../Room';
import type { AboutRoomPopupProps } from './types';

const popupClassNames = {
  modal: 'lt-modal-popup',
  closeButton: 'lt-modal-popup__close',
  overlay: 'lt-modal-popup__overlay',
};

const closeButtonStyles = {
  right: '0px',
  top: '-30px',
};

const AboutRoomPopup = ({
  opened,
  onClose,
  room,
  isMobile,
}: AboutRoomPopupProps) => {
  if (!room) return null;
  return (
    <Popup
      open={opened}
      onClose={onClose}
      classNames={popupClassNames}
      height="auto"
      width="auto"
      // @ts-ignore
      closeButtonStyles={isMobile ? closeButtonStyles : undefined}
    >
      <Room {...room} isMobile={isMobile} />
    </Popup>
  );
};

export default AboutRoomPopup;
